// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';

export default {
    
    async getRoles({ commit, state }, { id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = state.access_token;

            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_ROLES}/api/v1/roles`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
    async fetchSaveRole(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_ROLES}/api/v1/roles?name=${payload.name}`,
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }

    },
    async fetchDeleteRole(ctx, {id}){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.delete(`${process.env.VUE_APP_ROLES}/api/v1/roles/${id}`, config);
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
    async getRolesByUser(ctx, { user_id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = ctx.rootGetters.access_token;


            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/users/${user_id}/roles`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
    async assignRole(ctx, payload) {
        try {
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/users/${payload.user_id}/assign-role?role=${payload.role_name}`,
                {},
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                });

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
    async removeRole(ctx, payload) {
        try {
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/users/${payload.user_id}/remove-role?role=${payload.role_name}`,
                {},
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                });

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
};
